module.exports = __webpack_public_path__ + "static/img/手机端商品.478de68e.png";